export enum InventoryDocumentType {
    LICENSE = "License",
    ELECTRICITY_BILL = "Electricity Bill",
    ELECTRICITY_APPROVAL_DOCS = "Electricity Approval docs",
    STRUCTURE_DESIGN = "Structure Design",
}